import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import TechnicianRepository from '@/shared/http/repositories/realestate/technician'
import EngineerRepository from '@/shared/http/repositories/realestate/engineer'

export default {
  name: 'tableTecnicoEngenheiro',
  mixins: [ActionsForm],
  props: ['tipo'],
  components: {},
  data () {
    return {
      colum: ['NOME', 'DATA DE CRIAÇÃO', 'DATA DE NASCIMENTO', 'TELEFONE', 'CPF', 'EMAIL', ''],
      dados: [],
      id: null,
      edicao: false,
      cpfValido: false,
      additem: {},
      usuario: null,
      categoria: null,
      formSearch: {},
      validaformTecnico: false
    }
  },

  mounted () {
    this.onLoadTable(this.tipo)
  },
  watch: {
    'additem.cpf' (newValue) {
      if (newValue !== null) {
        this.CPFValidator()
      }
    }
  },
  methods: {
    validateState (ref) {
      if (ref === 'cpf-tec-eng' && this.additem.cpf && this.additem.cpf.length === 14) {
        var resultado = this.CPFValidator()
        if (resultado === false) {
          this.veeFields[ref].validated = false
          this.veeFields[ref].dirty = false
          return this.errors.has(ref)
        }
      }
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    CPFValidator () {
      if (this.validarCPF(this.additem.cpf)) {
        this.cpfValido = true
        return true
      } else {
        toast.error('Ops! CPF inválido!')
        return false
      }
    },
    validarCPF (cpf) {
      cpf = cpf.replace(/[^\d]/g, '')
      if (cpf.length !== 11 || /^(.)\1+$/.test(cpf)) return false

      const digitoVerificador1 = this.calcularDigitoVerificador(cpf, 9)
      const digitoVerificador2 = this.calcularDigitoVerificador(cpf, 10, digitoVerificador1)
      return cpf.charAt(9) === String(digitoVerificador1) && cpf.charAt(10) === String(digitoVerificador2)
    },
    calcularDigitoVerificador (cpfParcial, peso, digitoVerificadorAnterior = 0) {
      let soma = 0
      for (let i = 0; i < peso; i++) {
        soma += parseInt(cpfParcial.charAt(i)) * (peso + 1 - i)
      }
      soma += digitoVerificadorAnterior * (peso + 1) // Adicionando o dígito verificador anterior
      const resto = soma % 11
      return resto < 2 ? 0 : 11 - resto
    },

    onLoadTable (tipo) {
      loading.push()
      var filtros = {
        Nome: this.formSearch.Nome === undefined ? '' : this.formSearch.Nome,
        Cpf: '',
        DataCriacaoInicio: this.formSearch.DataInclusaoInicio === undefined ? null : this.formSearch.DataInclusaoInicio,
        DataCriacaoFim: this.formSearch.DataInclusaoFim === undefined ? null : this.formSearch.DataInclusaoFim
      }
      this.categoria = tipo
      if (this.categoria === 0) {
        EngineerRepository.getGridEngenheiro(this.$refs.tableOcorrenciaTecnicoEngenheiro.pagingLimit, this.$refs.tableOcorrenciaTecnicoEngenheiro.pagingIndex, filtros)
          .then((Response) => {
            loading.pop()
            this.$refs.tableOcorrenciaTecnicoEngenheiro.LoadAllByData(Response)
            this.dados = Response.data.data
          })
          .catch((Error) => {
            loading.pop()
          })
      }
      if (this.categoria === 1) {
        TechnicianRepository.getGridTecnico(this.$refs.tableOcorrenciaTecnicoEngenheiro.pagingLimit, this.$refs.tableOcorrenciaTecnicoEngenheiro.pagingIndex, filtros)
          .then((Response) => {
            loading.pop()
            this.$refs.tableOcorrenciaTecnicoEngenheiro.LoadAllByData(Response)
            this.dados = Response.data.data
          })
          .catch((Error) => {
            loading.pop()
          })
      }
    },

    validaTecnicoEngenheiro () {
      if ((this.additem.nome != null || this.additem.nome !== undefined) && (this.additem.telefone != null || this.additem.telefone !== undefined) &&
        (this.additem.cpf != null || this.additem.cpf !== undefined) &&
        (this.additem.datanascimento != null || this.additem.datanascimento !== undefined) &&
        (this.additem.email != null || this.additem.email !== undefined)) {
        if (!this.additem.email.includes('@')) {
          toast.error(`O campo E-mail esta invalido!!`)
        } else {
          this.validaformTecnico = true
        }
      } else {
        this.validaformTecnico = false
        if (this.additem.nome == null || this.additem.nome !== undefined) {
          toast.warning('Nome deve ser preenchido!!')
        }
        if (this.additem.telefone == null || this.additem.telefone !== undefined) {
          toast.warning('Telefone deve ser preenchido!!')
        }
        if (this.additem.cpf == null || this.additem.cpf !== undefined) {
          toast.warning('Cpf deve ser preenchido!!')
        }
        if (this.additem.datanascimento == null || this.additem.datanascimento !== undefined) {
          toast.warning('Data de Nascimento deve ser preenchido!!')
        }
        if (this.additem.email == null || this.additem.email !== undefined) {
          toast.warning('E-mail deve ser preenchido!!')
        }
      }
    },
    addTecnico () {
      loading.push()
      this.validaTecnicoEngenheiro()
      if (this.validaformTecnico === true) {
        TechnicianRepository.Post(this.additem)
          .then((Response) => {
            loading.pop()
            if (Response.data) {
              toast.success('Técnico inserido com sucesso!')
              this.additem = {}
              this.onLoadTable(this.tipo)
              this.fechaPopAddEdicao()
            } else {
              toast.error('Não foi possivel salvar um técnico!')
              this.additem = {}
            }
            this.back()
          })
          .catch((Error) => {
            loading.pop()
            console.error(Error)
          })
      } else {
        loading.pop()
      }
    },
    addEngenheiro () {
      loading.push()
      this.validaTecnicoEngenheiro()
      if (this.validaformTecnico === true) {
        EngineerRepository.Post(this.additem)
          .then((Response) => {
            loading.pop()
            if (Response.data) {
              toast.success('Engenheiro inserido com sucesso!')
              this.onLoadTable(this.tipo)
              this.fechaPopAddEdicao()
            } else {
              toast.error('Não foi possivel salvar um Engenheiro!')
            }
            this.back()
          })
          .catch((Error) => {
            loading.pop()
            console.error(Error)
          })
      } else {
        loading.pop()
      }
    },

    UpdateEngenheiro () {
      loading.push()
      this.validaTecnicoEngenheiro()
      if (this.validaformTecnico === true) {
        EngineerRepository.Update(this.additem)
          .then((Response) => {
            loading.pop()
            if (Response.data) {
              toast.success('Engenheiro alterado com sucesso!')
              this.onLoadTable(this.tipo)
              this.fechaPopAddEdicao()
            } else {
              toast.error('Não foi possível alterado o Engenheiro!')
              this.additem = {}
            }
            this.back()
          })
          .catch((Error) => {
            loading.pop()
            console.error(Error)
          })
      } else {
        loading.pop()
      }
    },

    UpdateTecnico () {
      loading.push()
      this.validaTecnicoEngenheiro()
      if (this.validaformTecnico === true) {
        TechnicianRepository.Update(this.additem)
          .then((Response) => {
            loading.pop()
            if (Response.data) {
              toast.success('Engenheiro alterado com sucesso!')
              this.onLoadTable(this.tipo)
              this.fechaPopAddEdicao()
            } else {
              toast.error('Não foi possível alterado o Engenheiro!')
              this.additem = {}
            }
            this.back()
          })
          .catch((Error) => {
            loading.pop()
            console.error(Error)
          })
      } else {
        loading.pop()
      }
    },

    DeleteEngenheiro () {
      loading.push()
      EngineerRepository.Delete(this.additem)
        .then((Response) => {
          loading.pop()
          if (Response.data) {
            toast.success('Engenheiro Excluído com sucesso!')
            this.onLoadTable(this.tipo)
            this.fechaPopExclusao()
          } else {
            toast.error('Não foi possível excluir o Engenheiro!')
            this.additem = {}
          }
          this.back()
        })
        .catch((Error) => {
          loading.pop()
          console.error(Error)
        })
    },
    DeleteTecnico () {
      loading.push()
      TechnicianRepository.Delete(this.additem)
        .then((Response) => {
          loading.pop()
          if (Response.data) {
            toast.success('Técnico Excluído com sucesso!')
            this.onLoadTable(this.tipo)
            this.fechaPopExclusao()
          } else {
            toast.error('Não foi possível excluir o Técnico!')
            this.additem = {}
          }
          this.back()
        })
        .catch((Error) => {
          loading.pop()
          console.error(Error)
        })
    },
    popUpAdd (value) {
      this.additem = {}
      this.edicao = false
      this.$refs['add-cadastro'].show()
    },
    popUpEdicao (value) {
      this.edicao = true
      this.id = value.id
      this.additem.cpf = value.cpf
      this.additem.nome = value.nome
      this.additem.telefone = value.telefone
      this.additem.email = value.email
      this.additem.datanascimento = value.dataNascimento.split('T')[0]
      this.additem.id = value.id

      this.$refs['add-cadastro'].show()
    },
    fechaPopAddEdicao () {
      this.$refs['add-cadastro'].hide()
    },
    popUpExclusao (value) {
      this.additem = {}
      this.additem.id = value.id
      this.usuario = value.nome
      this.$refs['exclusao'].show()
    },
    fechaPopExclusao (value) {
      this.$refs['exclusao'].hide()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/occurrenceMaintenance/components/tabla/table.js